import React from "react";
import PropTypes from "prop-types";
import { isPresentationProject } from "@utils/presentationMode";

const PresentationMutationGate = ({ project, children }) => (
  isPresentationProject(project) ? null : children
);

PresentationMutationGate.propTypes = {
  project: PropTypes.object,
  children: PropTypes.node,
};

PresentationMutationGate.defaultProps = {
  project: null,
  children: null,
};

export default PresentationMutationGate;
